"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
/** syntactic sugar for using JSX syntax with ReactDOM.createPortal */
var Portal = function Portal(_ref) {
  var _ref$node = _ref.node,
    node = _ref$node === void 0 ? document.body : _ref$node,
    children = _ref.children;
  return /*#__PURE__*/_reactDom["default"].createPortal(children, node);
};
var _default = Portal;
exports["default"] = _default;
//# sourceMappingURL=Portal.js.map